import { useState } from 'react';
import { dateRanges } from '../../components/Input';
import { DateRangePickerInput } from '../../components/Input/DateRangePickerInput';
import { InternalTabsList } from '../components/InternalTabsList';
import { SurveyResponsesTiles } from '../components/SurveyResponsesTiles';

export function SurveysTab() {
  const [dateRange, setDateRange] = useState<[Date, Date] | null>(dateRanges.last30days.value);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-between">
        <InternalTabsList />
        <DateRangePickerInput
          value={dateRange}
          onChange={setDateRange}
          className="w-[350px]"
          testId="date-range-input"
        />
      </div>

      <SurveyResponsesTiles dateRange={dateRange} />
    </div>
  );
}
